import { ApprovalCard } from '../../../pages/taxesAndInvoices/molecules/ApprovalCard';
import { ApprovalDeclaration } from '../../../@types/Declarations.type';
import { getCompleteMonth } from '../../../shared/utils/dates.util';
import { Skeleton, useMediaQuery } from '@mui/material';
import HomeCard from '../../../components/molecules/HomeCard';
import Button from '../../../components/atoms/Button';
import { ArrowRight, FileDashed } from '@phosphor-icons/react';
import { useNavigate } from 'react-router-dom';
import ROUTES from '../../../shared/constants/routes';
interface SliderProps {
	declarationsPending?: ApprovalDeclaration[];
	isLoading?: boolean;
	viewHome?: boolean;
	flow?: boolean;
}

export const Slider = ({
	declarationsPending,
	isLoading,
	viewHome = false,
}: SliderProps) => {
	const isMobile = useMediaQuery('(max-width: 768px)');
	const navigate = useNavigate();

	if (isLoading) {
		return (
			<div className='flex overflow-x-auto no-scrollbar snap-x snap-mandatory'>
				<div className='flex gap-4'>
					{Array.from(new Array(3)).map((_, index) => (
						<div
							key={`skeleton-${index}`}
							className='w-72 bg-white mt-[16px] rounded-lg inline-flex flex-col justify-start items-start gap-6 snap-center shrink-0 p-4'
						>
							{/* Header skeleton */}
							<div className='flex flex-col gap-2'>
								<Skeleton
									width={120}
									height={20}
								/>
								<Skeleton
									width={80}
									height={16}
								/>
							</div>

							{/* Amount section skeleton */}
							<div className='flex items-end gap-2'>
								<Skeleton
									variant='circular'
									width={30}
									height={30}
								/>
								<div className='flex flex-col gap-1'>
									<Skeleton
										width={140}
										height={16}
									/>
									<div className='flex items-end gap-2'>
										<Skeleton
											width={100}
											height={24}
										/>
										<Skeleton
											width={60}
											height={16}
										/>
									</div>
								</div>
							</div>

							{/* Verification section skeleton */}
							<div className='self-stretch p-4 bg-h-neutral-94 rounded-lg inline-flex flex-col justify-center items-start gap-4 w-full'>
								<Skeleton
									width={120}
									height={16}
								/>
								{Array.from(new Array(3)).map((_, i) => (
									<div
										key={`verification-${i}`}
										className='flex items-center gap-2 w-full'
									>
										<Skeleton
											variant='circular'
											width={16}
											height={16}
										/>
										<Skeleton
											width='80%'
											height={16}
										/>
									</div>
								))}
							</div>

							{/* Button skeleton */}
							<Skeleton
								variant='rectangular'
								width='100%'
								height={40}
								sx={{ borderRadius: 2 }}
							/>
						</div>
					))}
				</div>
			</div>
		);
	}

	if (!declarationsPending || declarationsPending.length === 0 || declarationsPending.every(declaration => declaration.fft_status === 'completed')) {
		return (
			<div className='flex flex-col items-center justify-center p-8 text-center'>
				<FileDashed
					size={50}
					color='#b3b3b3'
				/>
				<p className='text-h-neutral-60 text-lg mt-4'>
					Por el momento no tienes declaraciones pendientes por aprobar{' '}
				</p>
			</div>
		);
	}

	return (
		<>
			{viewHome && (
				<HomeCard
					title='Aprobación de declaraciones'
					showButton={false}
					href='#fiscalform'
					headerButton={
						<>
							{declarationsPending.length > 1 && (
								<Button
									onClick={() => {
										navigate(ROUTES.TAXES);
									}}
									type='button'
									label={isMobile ? 'Ver todos' : 'Ver todas mis declaraciones'}
									variant='text'
									icon={<ArrowRight size={20} />}
									labelColor='primary'
								/>
							)}
						</>
					}
				>
					<div className='flex overflow-x-auto no-scrollbar snap-x snap-mandatory'>
						<div className='flex gap-4'>
							{declarationsPending
								.filter(
									(declaration) => declaration?.fft_status !== 'completed',
								)
								.map((declaration, index) => (
									<ApprovalCard
										key={index}
										month={getCompleteMonth(Number(declaration?.detail?.month))}
										year={declaration?.detail?.year}
										platform='PLATAFORMAS TECNOLÓGICAS'
										amount={declaration?.detail?.totalBalance}
										fftId={declaration?.fft_id}
										status={declaration?.status}
										length={declarationsPending.length}
										viewHome={viewHome}
										user_id={declaration?.user_id}
									/>
								))}
						</div>
					</div>
				</HomeCard>
			)}

			{!viewHome && (
				<div
					className={`flex overflow-x-auto no-scrollbar snap-x snap-mandatory ${
						declarationsPending.length > 3 ? '' : 'md:justify-center'
					}`}
				>
					<div className='flex gap-4'>
						{declarationsPending
							.filter((declaration) => declaration?.fft_status !== 'completed')
							.map((declaration, index) => (
								<ApprovalCard
									key={index}
									month={getCompleteMonth(Number(declaration?.detail?.month))}
									year={declaration?.detail?.year}
									platform='PLATAFORMAS TECNOLÓGICAS'
									amount={declaration?.detail?.totalBalance}
									fftId={declaration?.fft_id}
									status={declaration?.status}
									length={declarationsPending.length}
									viewHome={viewHome}
									user_id={declaration?.user_id}
								/>
							))}
					</div>
				</div>
			)}
		</>
	);
};
